// Stable per-browser guest identity. NOT secure — designed to prevent
// accidental fragmentation when the same person uploads with slightly different
// names ("Rob" vs "Robert"). Different browser = different identity by design.
const GUEST_KEY = "meyecam.guest_id";
const COOKIE_NAME = "meyecam_guest_id";

function readCookie() {
  if (typeof document === "undefined") return null;
  const m = document.cookie.match(/(?:^|;\s*)meyecam_guest_id=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : null;
}

function writeCookie(value) {
  if (typeof document === "undefined") return;
  // 5-year cookie so it survives most cache clears short of explicit cookie deletion
  const maxAge = 60 * 60 * 24 * 365 * 5;
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
}

function generate() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback v4 UUID
  const buf = new Uint8Array(16);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(buf);
  } else {
    for (let i = 0; i < 16; i++) buf[i] = Math.floor(Math.random() * 256);
  }
  buf[6] = (buf[6] & 0x0f) | 0x40;
  buf[8] = (buf[8] & 0x3f) | 0x80;
  const hex = Array.from(buf, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function getGuestId() {
  let id = null;
  try { id = localStorage.getItem(GUEST_KEY); } catch (_) {}
  if (!id) id = readCookie();
  if (!id) {
    id = generate();
  }
  // Always sync both stores so a clear of either is recoverable from the other
  try { localStorage.setItem(GUEST_KEY, id); } catch (_) {}
  writeCookie(id);
  return id;
}
